module.exports = __webpack_public_path__ + "img/pic9.ff743bb9.png";